import React, { useState, useContext, useEffect } from 'react'

import { Form, Input, Modal, Upload, Select } from 'antd'

import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import SL_Button from '../../components/buttons/Button';
import { displayMessage } from '../../services/helper'
import moment from 'moment'
import { InboxOutlined } from '@ant-design/icons';
import ELanguages from '../../enums/ELanguages';

const inputsClassName = `border-appian-blue max-h-9 text-base`
const { Dragger } = Upload;


export default function DetailExercise(props) {

    const [form] = Form.useForm()
    const movieUrl = Form.useWatch('movieUrl', form)
    const openingVideo = Form.useWatch('openingVideo', form);
    const replayVideo = Form.useWatch('replayVideo', form);
    const intervalVideo = Form.useWatch('intervalVideo', form);
    const closingVideo = Form.useWatch('closingVideo', form);
    const audio = Form.useWatch('audio', form);

    const [exercise, setExercise] = useState(null)
    const [originalExercise, setOriginalExercise] = useState(null)
    const [edit_mode, setEditMode] = useState(false)

    const { currentExercise } = props
    const { setShowLoading, windowHeight, mobile_mode, enums } = useContext(GeneralContext)

    const {Option} = Select

    useEffect(() => {
        loadExercise()
    }, [currentExercise])

    function loadExercise() {
        setShowLoading(true)
        api.exercise.get(props.exercise_id)
            .then(
                rs => {
                    rs.data.birth_date = moment(rs.data.birth_date)
                    setExercise(rs.data)
                    setOriginalExercise(rs.data)
                    form.setFieldsValue(rs.data)
                }
            )
            .finally(
                setShowLoading(false)
        )
    }

    const handleUpdatePatient = async (values) => {
        const MAX_MB = 500;
        const FILE_SIZE_LIMIT = MAX_MB * 1024 * 1024;
        setShowLoading(true);
        try {
          const fileObj = {
            // movieUrl: values.movieUrl?.file?.originFileObj,
            openingVideo: values.openingVideo?.file?.originFileObj,
            replayVideo: values.replayVideo?.file?.originFileObj,
            intervalVideo: values.intervalVideo?.file?.originFileObj,
            closingVideo: values.closingVideo?.file?.originFileObj,
            audio: values.audio?.file?.originFileObj
          };
      
          const formDataBody = new FormData();
      
          Object.entries(fileObj).forEach(([key, file]) => {
            if (file?.size && file.size > FILE_SIZE_LIMIT) {
              alert(displayMessage('FILE_SIZE_LIMIT_EXCEEDED', [key, "500mb"]), 'warning');
              return;
            }
            if (file) {
              formDataBody.append(key, file);
            }
          });
      
          formDataBody.append('name', values.name);
          formDataBody.append('description', values?.description ?? '');
          formDataBody.append('videoRepeatCount', values?.videoRepeatCount);
          formDataBody.append('language', values?.language);
      
          await api.exercise.update(exercise.id, formDataBody);
          alert(displayMessage('UPDATE_EXERCISE_SUCCESS'), 'success', displayMessage('SUCCESS'));
          props.handleOnCloseModal();
          props.refreshExercises();
        } catch (error) {
          console.log(error);
        } finally {
          setShowLoading(false);
        }
      }
      

    const modalHeader = (
        <div className="text-xl font-bold text-appian-blue" style={{ display: 'flex', justifyContent: mobile_mode ? 'center' : 'flex-start', marginBottom: mobile_mode ? 10 : ''}}>
            {displayMessage('DETAIL_EXERCISE')}
        </div>
    )
    
    const handleSetFile = (file) => {
        console.log("File selected:", file);
        form.setFieldsValue({ movieUrl: file.name, file });
        console.log("Form values after setting file:", form.getFieldsValue());
        return false;
    }

    return (
        <>
            <Modal
                title={modalHeader}
                visible={props.isModalVisible}
                onCancel={props.handleOnCloseModal}
                centered={true}
                width={750}
                style={{ position: 'relative' }}
                bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto' }}
                footer={<div></div>}
            >
                <Form
                    className='w-full flex flex-col gap-2 p-5'
                    onFinish={handleUpdatePatient}
                    layout="vertical"
                    requiredMark='optional'
                    form={form}
                >
                    <div>
                        <Form.Item
                            label={displayMessage('NAME')}
                            name="name"
                            className={`w-full flex`}
                            rules={[{ required: true, message: displayMessage('FULL_NAME_MANDATORY') }]}
                        >
                            <Input
                                type="text"
                                size='large'
                                disabled={!edit_mode}
                                placeholder={displayMessage('NAME')}
                                className={inputsClassName}
                            />
                        </Form.Item>
    
                <Form.Item
                    label={displayMessage('VIDEO_REPEAT_COUNT')}
                    name="videoRepeatCount"
                    rules={[{ required: true, message: displayMessage('VIDEO_REPEAT_COUNT_MANDATORY') }]}
                    className={`w-full flex`}
                >
                    <Input
                        type="number"
                        min={0}
                        size='large'
                        disabled={!edit_mode}
                        placeholder={displayMessage('VIDEO_REPEAT_COUNT')}
                        className={inputsClassName}

                    />
                    
                </Form.Item>
                <Form.Item
                            label={displayMessage('DESCRIPTION')}
                            name="description"
                            className={`w-full flex`}
                            rules={[{ required: true, message: displayMessage('FULL_NAME_MANDATORY') }]}
                        >
                            <Input
                                type="text"
                                size='large'
                                disabled={!edit_mode}
                                placeholder={displayMessage('LAST_NAME')}
                                className={inputsClassName}
                            />
                        </Form.Item>
                        <Form.Item
          
                >
                <Form.Item
                    label={displayMessage('LANGUAGE')}
                    name="language"
                    className={`w-full flex`}
                    rules={[
                      { required: true, message: displayMessage('LANGUAGE_MANDATORY') },
                    ]}
                >
                    <Select
                        disabled={!edit_mode}
                        allowClear
                        type="text"
                        size='large'
                        placeholder={displayMessage('LANGUAGE')}
                        className={inputsClassName}

                    >
               {Object.values(ELanguages).map((type) => (
    <Option key={type.code} value={type.code}>
        {type.description}
    </Option>
))}
                    </Select>
                </Form.Item>                
                </Form.Item>
                        {/* <Form.Item
                            label={displayMessage('ATTACHMENT')}
                            name="movieUrl"
                            className={`w-full flex`}
                            rules={[{ required: true, message: displayMessage('FULL_NAME_MANDATORY') }]}
                        >
                            <Dragger
                                name='file'
                                multiple={false}
                                disabled={!edit_mode}
                                beforeUpload={handleSetFile}
                                accept="video/*,image/*"
                                showUploadList={false}
                                className="!bg-white border border-appian-blue p-4"
                            >
                                <p className="ant-upload-drag-icon"> <InboxOutlined/> </p>
                                <p className="ant-upload-text">{displayMessage('CLICK_OR_DRAG_FILE')}</p>
                                <p className="ant-upload-hint">{exercise?.movieUrl || displayMessage('NO_FILE_SELECTED')}</p>
                            </Dragger>
                        </Form.Item> */}
                        {/* <Form.Item
                            label={displayMessage('ATTACHMENT')}
                            name="movieUrl"
                            className={`w-full flex`}
                        >
                            <Dragger
                                name="file"
                                multiple={false}
                                disabled={!edit_mode}
                                beforeUpload={()=>{return null}}
                                accept="video/*,image/*"
                                showUploadList={false}
                                className="!bg-white border border-appian-blue p-4"
                            >
                                <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                                <p className="ant-upload-text">{displayMessage('CLICK_OR_DRAG_FILE')}</p>
                                <p className="ant-upload-hint">{movieUrl?.file?.name || displayMessage('NO_FILE_SELECTED')}</p>
                            </Dragger>
                        </Form.Item> */}
                        <Form.Item
          label={displayMessage("OPENING_VIDEO")}
          name="openingVideo"
          className={`w-full flex`}
        >
          <Dragger
            name="file"
            multiple={false}
            disabled={!edit_mode}
            beforeUpload={() => {
              return null;
            }}
            accept="video/*,image/*"
            showUploadList={false}
            className="!bg-white border border-appian-blue p-4"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              {displayMessage("CLICK_OR_DRAG_FILE")}
            </p>
            <p className="ant-upload-hint">
  {openingVideo?.file?.name || displayMessage("NO_FILE_SELECTED")}
</p>
          </Dragger>
        </Form.Item>
        <Form.Item
          label={displayMessage("REPLAY_VIDEO")}
          name="replayVideo"
          className={`w-full flex`}
        >
          <Dragger
            name="file"
            multiple={false}
            disabled={!edit_mode}
            beforeUpload={() => {
              return null;
            }}
            accept="video/*,image/*"
            showUploadList={false}
            className="!bg-white border border-appian-blue p-4"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              {displayMessage("CLICK_OR_DRAG_FILE")}
            </p>
            <p className="ant-upload-hint">
  {replayVideo?.file?.name || displayMessage("NO_FILE_SELECTED")}
</p>
          </Dragger>
        </Form.Item>
        <Form.Item
          label={displayMessage("INTERVAL_VIDEO")}
          name="intervalVideo"
        >
           <Dragger
            name="file"
            multiple={false}
            disabled={!edit_mode}
            beforeUpload={() => {
              return null;
            }}
            accept="video/*,image/*"
            showUploadList={false}
            className="!bg-white border border-appian-blue p-4"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              {displayMessage("CLICK_OR_DRAG_FILE")}
            </p>
            <p className="ant-upload-hint">
              {intervalVideo?.file?.name || displayMessage("NO_FILE_SELECTED")}
            </p>
          </Dragger>
        </Form.Item>
        <Form.Item label={displayMessage("CLOSING_VIDEO")} 
        name="closingVideo"
        >
        <Dragger
            name="file"
            multiple={false}
            disabled={!edit_mode}
            beforeUpload={() => {
              return null;
            }}
            accept="video/*,image/*"
            showUploadList={false}
            className="!bg-white border border-appian-blue p-4"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              {displayMessage("CLICK_OR_DRAG_FILE")}
            </p>
            <p className="ant-upload-hint">
              {closingVideo?.file?.name || displayMessage("NO_FILE_SELECTED")}
            </p>
          </Dragger>
        </Form.Item>
        <Form.Item label={displayMessage("AUDIO")} 
        name="audio"
        >      
        <Dragger
            name="file"
            multiple={false}
            disabled={!edit_mode}
            beforeUpload={() => {
              return null;
            }}
            accept="audio/*"
            showUploadList={false}
            className="!bg-white border border-appian-blue p-4"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              {displayMessage("CLICK_OR_DRAG_FILE")}
            </p>
            <p className="ant-upload-hint">
              {audio?.file?.name || displayMessage("NO_FILE_SELECTED")}
            </p>
          </Dragger>
        </Form.Item>
                        <div className={`flex flex-row ${edit_mode ? 'justify-between' : 'content-end'} items-center`}>
                            <SL_Button
                                type={"primary"}
                                styles={{ display: 'flex', flex:1 }}
                                className="border-appian-blue h-9 text-base max-w-md sticky bottom-[-20px] "
                                onClick={e => {
                                    setEditMode(!edit_mode)
                                    form.setFieldsValue(!edit_mode ? originalExercise :exercise)
                                }}
                            >
                                {displayMessage(!edit_mode ? 'EDIT' : 'CANCEL')}
                            </SL_Button>
                                
                            {
                                edit_mode ?
                                    <SL_Button
                                        type="primary"
                                        size='large'
                                        htmlType="submit"
                                        className="border-appian-blue h-9 text-base max-w-md sticky bottom-[-20px]"
                                    >
                                        {displayMessage('UPDATE_EXERCISE')}
                                    </SL_Button>
                                    :
                                    null
                            }                            
                        </div>
                    </div>
                </Form>
            </Modal >
        </>
    )
}

